export function replaceByProductInstallmentsPlan(
  authorizerData: any,
  authorizer: string,
  productName: string,
  installments: string
): string {
  if (installments === null || installments === undefined) return '';

  const transactionAuthorizer = authorizerData?.find((data: any) => data?.name === authorizer);
  if (!transactionAuthorizer) return String(installments);

  const installmentsPlan = transactionAuthorizer?.product?.metadata?.transactionData?.installmentsPlan;

  if (transactionAuthorizer?.product?.name === productName && installmentsPlan && installmentsPlan[installments]) {
    const entry = installmentsPlan[installments];
    const desc = entry?.desc;
    if (desc) return String(desc);
    if (typeof entry === 'object' && entry !== null) return String(installments);
    return String(entry);
  }

  return String(installments);
}
